import axios from "axios";
import { useEffect } from "react";
import { API, getDeviceId } from "@/lib/api";

const base = () => `${API}/family/${getDeviceId()}`;
const pinHeader = (pin) => ({ headers: { "X-Parent-Pin": pin } });

export const AWARD_REASONS = [
  "Used advanced manners language",
  "Polite consistently all week",
  "Ordered well at a restaurant",
  "Answered the phone properly",
  "Sent a proper email",
  "Wrote a thank-you note unprompted",
  "Great teacher report on respect",
  "Included someone who was left out",
  "Stood up kindly for a classmate",
  "Gave all 3 steps of an apology",
];

export const getRewards = async (profileId) => (await axios.get(`${base()}/rewards`, { params: profileId ? { profile_id: profileId } : {} })).data;
const changed = (d) => { window.dispatchEvent(new Event("pp-rewards-changed")); return d; };
export const useRewardsChanged = (fn) => useEffect(() => {
  window.addEventListener("pp-rewards-changed", fn);
  return () => window.removeEventListener("pp-rewards-changed", fn);
}, [fn]);
export const saveRewards = async (pin, rewards) => changed((await axios.put(`${base()}/rewards`, { rewards }, pinHeader(pin))).data);
export const giveAward = async (pin, body) => changed((await axios.post(`${base()}/awards`, body, pinHeader(pin))).data);
export const getAwards = async (profileId) => (await axios.get(`${base()}/awards`, { params: { profile_id: profileId } })).data;
export const redeemReward = async (pin, profileId, rewardId) =>
  changed((await axios.post(`${base()}/redeem`, { profile_id: profileId, reward_id: rewardId }, pinHeader(pin))).data);

const shrink = (file, max = 1600) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const k = Math.min(1, max / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    c.toBlob((b) => resolve(b || file), "image/jpeg", 0.85);
  };
  img.onerror = () => resolve(file);
  img.src = URL.createObjectURL(file);
});

export const uploadAwardPhoto = async (pin, awardId, file) => {
  const fd = new FormData();
  fd.append("file", await shrink(file), "teacher-note.jpg");
  return (await axios.post(`${base()}/awards/${awardId}/photo`, fd, pinHeader(pin))).data;
};
export const awardPhotoUrl = (awardId) => `${base()}/awards/${awardId}/photo`;
export const getAllAwards = async () => (await axios.get(`${base()}/awards`)).data;
export const deleteAwardPhoto = async (pin, awardId) => (await axios.delete(`${base()}/awards/${awardId}/photo`, pinHeader(pin))).data;
